/** AI token-usage views. The learner sees their own day/week/month "% left";
 *  tenant-admins and super-admins get roster / per-tenant breakdowns. */
import { request } from "./http";

export interface UsageWindow {
  used: number;
  limit: number;
}

export interface MyAiUsage {
  /** The one that normally bites: the free tier is one two-minute
   *  conversation a day. */
  day: UsageWindow;
  week: UsageWindow;
  month: UsageWindow;
}

export interface LearnerUsage {
  user_id: string;
  full_name: string;
  email: string;
  tokens_this_month: number;
}

export interface TenantUsage {
  tenant_id: string;
  name: string;
  tokens_this_month: number;
}

export function myAiUsage(): Promise<MyAiUsage> {
  return request("/ai-usage/me");
}

export function tenantLearnerUsage(): Promise<LearnerUsage[]> {
  return request("/ai-usage/learners");
}

export function platformTenantUsage(): Promise<TenantUsage[]> {
  return request("/ai-usage/tenants");
}
